var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12C4.75 10.0932 4.75159 8.73851 4.88976 7.71085C5.02502 6.70476 5.27869 6.12511 5.7019 5.7019C6.12511 5.27869 6.70476 5.02502 7.71085 4.88976C8.73851 4.75159 10.0932 4.75 12 4.75C13.9068 4.75 15.2615 4.75159 16.2892 4.88976C17.2952 5.02502 17.8749 5.27869 18.2981 5.7019C18.7213 6.12511 18.975 6.70476 19.1102 7.71085C19.2484 8.73851 19.25 10.0932 19.25 12C19.25 13.9068 19.2484 15.2615 19.1102 16.2892C18.975 17.2952 18.7213 17.8749 18.2981 18.2981C17.8749 18.7213 17.2952 18.975 16.2892 19.1102C15.2615 19.2484 13.9068 19.25 12 19.25C10.0932 19.25 8.73851 19.2484 7.71085 19.1102C6.70476 18.975 6.12511 18.7213 5.7019 18.2981C5.27869 17.8749 5.02502 17.2952 4.88976 16.2892C4.75159 15.2615 4.75 13.9068 4.75 12Z",
    stroke: "#85909F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.7a3f7581d94d8f1e3dd393382c85a17d.svg";
export { ForwardRef as ReactComponent };